import script from "./sf-banner-system.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-banner-system.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__